import type { JSX } from 'react';
export interface WsIndexHeaderProps {
  userName: string;
  onCreateContent: () => void;
}

/**
 * ホーム画面 ヘッダー + コンテンツ作成ボタンコンポーネント
 */
export default function WsIndexHeader({
  userName,
  onCreateContent,
}: WsIndexHeaderProps): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <div className="container">
      <div className="d-md-flex d-flex-header">
        <div className="flex-shrink-0 flex-left">
          <h2 className="flex-title">こんにちは、{userName}さん</h2>
        </div>
        <div className="flex-grow-1 flex-right">
          <ul className="list-inline list-btn mb-0">
            <li className="list-inline-item mw-238">
              <a onClick={onCreateContent} className="btn btn-common btn-common-w238 outline-blue">
                + 新しいコンテンツを作成する
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
